import { useState } from "react";
import {
  RequestLWAStartAuthRequest,
  AmazonLwaStartPostRequest,
  AmazonApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiStartLwaAuth = () => {
  const [authorizeUrl, setAuthorizeUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const startLwaAuth = async (req: RequestLWAStartAuthRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonLwaStartPostRequest = { req };

      const api = new AmazonApi(config);
      const response = await api.amazonLwaStartPost(request); // { authorize_url: string }

      setAuthorizeUrl(response.authorize_url);
      return response; // 呼び出し元で window.location.href = response.authorize_url;
    } catch (err) {
      console.error(err);
      setError("Amazon連携URLの取得に失敗しました");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { startLwaAuth, authorizeUrl, error, isLoading };
};
